module.exports = "/images/bandeirasaopaulo.jpg?feb89e6b660295fad1ac77302c5cb30e";